// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__JisoW","mobileHeader":"page_mobileHeader__tN4V_"};